import { getObjectByPath } from '../../../utils/applyMenuConfigChanges/utils';
import { removeStartingSlash } from '../../../utils/locationUtils';

export const getNodeByPath = (tree, link: string = '') => {
  const linkKeys = removeStartingSlash(link)
    .split('/')
    .map((key) => `/${key.toLowerCase()}`);
  return getObjectByPath(tree, linkKeys);
};

export const getNodeByLink = (tree, link: string = '') => {
  const node = getNodeByPath(tree, link);
  if (node?.data) {
    if (node.data.link === link) {
      return node;
    }

    const lookForLinkAt = [
      'operations',
      'clientEvents',
      'messages',
      'callbacks',
      'properties',
      'relatedGuides',
      'events',
    ];

    let relevantNode;

    for (const key of lookForLinkAt) {
      relevantNode = node?.data?.[key]?.find((param) => param.link === link);

      if (relevantNode) {
        return { data: relevantNode };
      }
    }
  }
};

export const isLinkExistInDocs = (tree: any = {}, link: string = '') =>
  !!getNodeByLink(tree, link);
